import React, { useState, useEffect } from "react";
import axios from "axios";
import LanguageSelector from "./LanguageSelector/LanguageSelector";
import { FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { TbBrandX } from "react-icons/tb"; // For the X (Twitter) icon
import API_URLS from "./apiConfig";
import { matchPath,useLocation } from "react-router-dom";

const Footer = () => {
  const [footerPageData, setFooterPageData] = useState(null);
  const [footerLinkData, setFooterLinkData] = useState(null);
  const homeUrl=API_URLS.baseFrontUrl;

  const location = useLocation();

  // Define routes where the footer description should appear
  const routesWithDescription = ["/", "/careers/:pagename/:id"];  
  const isRouteWithDescription = () => {
    return routesWithDescription.some((route) => matchPath(route, location.pathname));
  };

  
  useEffect(() => {
    const fetchData = async () => {
      axios
        .get(API_URLS.getFooter)
        .then((response) => {
          if (response.data) {
            setFooterPageData(response.data.footer);
            //console.log(response.data.footer);
          }
        })
        .catch((error) => {
          console.error("Error fetching menu data:", error);
        });
    };
    const fetchFooterLinkData = async () => {
      axios
        .get(API_URLS.getFooterLink)
        .then((response) => {
          if (response.data) {
            setFooterLinkData(response.data.data);
            //console.log(response.data.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching menu data:", error);
        });
    };
    fetchData(); 
    fetchFooterLinkData(); 
  }, []);
  if (!footerPageData) {
    return <div>Loading...</div>;
  }
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-container">
          {/* Left Section */}
          <div className="footer-left">
            <div className="footer-socials">
                <div className="footer-icons-outer">
                    <span>{footerPageData.follow_us_title}</span>
                    <div className="footer-icons">
                        <a
                        href="https://twitter.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-link x"
                        aria-label="X"
                        >
                        <TbBrandX size={24} color="#060606" />
                        </a>
                        <a
                        href="https://www.instagram.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-link instagram"
                        aria-label="Instagram"
                        >
                        <FaInstagram size={24} color="#060606" />
                        </a>
                        <a
                        href="https://www.linkedin.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-link linkedin"
                        aria-label="LinkedIn"
                        >
                        <FaLinkedinIn size={24} color="#060606" />
                        </a>
                    </div>
                </div>
            </div>
            <LanguageSelector />
            {/* <hr /> */}
          </div>
          <hr />
          {/* Center Section */}
          <div className="footer-links">
            <div className="footer-column">
              <ul>
                { 
                  footerLinkData ?
                    footerLinkData.map((footerlink, index) => (
                      <li key={index}>
                        <a href={homeUrl+footerlink.url}>{footerlink.links[0].url_title}</a>
                      </li>
                    ))
                  : null
                }  
              </ul>
            </div>
          </div>
          {/* Conditionally render footer description */}
          {/* {routesWithDescription.includes(location.pathname) && (
            <p className="footer-description">
              {footerPageData.footer_text}
            </p>
          )} */}
          {/* Conditionally render footer description */}
          {isRouteWithDescription() && (
            <p className="footer-description">
              {footerPageData.footer_text}
            </p>
          )}
        </div>

        {/* Footer Bottom Section */}
        <div className="footer-bottom">
          <p>{footerPageData.copyright_text}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
